/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MfaVerifyRouteImport } from './routes/mfa-verify'
import { Route as MfaEnrollRouteImport } from './routes/mfa-enroll'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedWebhooksRouteImport } from './routes/_authed/webhooks'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedTagsRouteImport } from './routes/_authed/tags'
import { Route as AuthedTagOrdersRouteImport } from './routes/_authed/tag-orders'
import { Route as AuthedTagBatchesRouteImport } from './routes/_authed/tag-batches'
import { Route as AuthedSchoolsRouteImport } from './routes/_authed/schools'
import { Route as AuthedReturnsRouteImport } from './routes/_authed/returns'
import { Route as AuthedReferralsRouteImport } from './routes/_authed/referrals'
import { Route as AuthedPromoCodesRouteImport } from './routes/_authed/promo-codes'
import { Route as AuthedPostalRouteImport } from './routes/_authed/postal'
import { Route as AuthedLaunchSubscribersRouteImport } from './routes/_authed/launch-subscribers'
import { Route as AuthedItemsRouteImport } from './routes/_authed/items'
import { Route as AuthedDiagnosticsRouteImport } from './routes/_authed/diagnostics'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedClaimsRouteImport } from './routes/_authed/claims'
import { Route as AuthedCharitiesRouteImport } from './routes/_authed/charities'
import { Route as AuthedCategoriesRouteImport } from './routes/_authed/categories'
import { Route as AuthedCatalogRouteImport } from './routes/_authed/catalog'
import { Route as AuthedAuditRouteImport } from './routes/_authed/audit'
import { Route as AuthedApiKeysRouteImport } from './routes/_authed/api-keys'
import { Route as AuthedUsersUidRouteImport } from './routes/_authed/users_.$uid'
import { Route as AuthedSchoolsIdRouteImport } from './routes/_authed/schools_.$id'
import { Route as AuthedPromoCodesCodeRouteImport } from './routes/_authed/promo-codes_.$code'
import { Route as AuthedCharitiesIdRouteImport } from './routes/_authed/charities_.$id'

const MfaVerifyRoute = MfaVerifyRouteImport.update({
  id: '/mfa-verify',
  path: '/mfa-verify',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaEnrollRoute = MfaEnrollRouteImport.update({
  id: '/mfa-enroll',
  path: '/mfa-enroll',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedWebhooksRoute = AuthedWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTagsRoute = AuthedTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTagOrdersRoute = AuthedTagOrdersRouteImport.update({
  id: '/tag-orders',
  path: '/tag-orders',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTagBatchesRoute = AuthedTagBatchesRouteImport.update({
  id: '/tag-batches',
  path: '/tag-batches',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSchoolsRoute = AuthedSchoolsRouteImport.update({
  id: '/schools',
  path: '/schools',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReturnsRoute = AuthedReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReferralsRoute = AuthedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPromoCodesRoute = AuthedPromoCodesRouteImport.update({
  id: '/promo-codes',
  path: '/promo-codes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPostalRoute = AuthedPostalRouteImport.update({
  id: '/postal',
  path: '/postal',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLaunchSubscribersRoute = AuthedLaunchSubscribersRouteImport.update({
  id: '/launch-subscribers',
  path: '/launch-subscribers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedItemsRoute = AuthedItemsRouteImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiagnosticsRoute = AuthedDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClaimsRoute = AuthedClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCharitiesRoute = AuthedCharitiesRouteImport.update({
  id: '/charities',
  path: '/charities',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCategoriesRoute = AuthedCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCatalogRoute = AuthedCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApiKeysRoute = AuthedApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersUidRoute = AuthedUsersUidRouteImport.update({
  id: '/users_/$uid',
  path: '/users/$uid',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSchoolsIdRoute = AuthedSchoolsIdRouteImport.update({
  id: '/schools_/$id',
  path: '/schools/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPromoCodesCodeRoute = AuthedPromoCodesCodeRouteImport.update({
  id: '/promo-codes_/$code',
  path: '/promo-codes/$code',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCharitiesIdRoute = AuthedCharitiesIdRouteImport.update({
  id: '/charities_/$id',
  path: '/charities/$id',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/mfa-enroll': typeof MfaEnrollRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/api-keys': typeof AuthedApiKeysRoute
  '/audit': typeof AuthedAuditRoute
  '/catalog': typeof AuthedCatalogRoute
  '/categories': typeof AuthedCategoriesRoute
  '/charities': typeof AuthedCharitiesRoute
  '/claims': typeof AuthedClaimsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/diagnostics': typeof AuthedDiagnosticsRoute
  '/items': typeof AuthedItemsRoute
  '/launch-subscribers': typeof AuthedLaunchSubscribersRoute
  '/postal': typeof AuthedPostalRoute
  '/promo-codes': typeof AuthedPromoCodesRoute
  '/referrals': typeof AuthedReferralsRoute
  '/returns': typeof AuthedReturnsRoute
  '/schools': typeof AuthedSchoolsRoute
  '/tag-batches': typeof AuthedTagBatchesRoute
  '/tag-orders': typeof AuthedTagOrdersRoute
  '/tags': typeof AuthedTagsRoute
  '/users': typeof AuthedUsersRoute
  '/webhooks': typeof AuthedWebhooksRoute
  '/charities/$id': typeof AuthedCharitiesIdRoute
  '/promo-codes/$code': typeof AuthedPromoCodesCodeRoute
  '/schools/$id': typeof AuthedSchoolsIdRoute
  '/users/$uid': typeof AuthedUsersUidRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/mfa-enroll': typeof MfaEnrollRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/api-keys': typeof AuthedApiKeysRoute
  '/audit': typeof AuthedAuditRoute
  '/catalog': typeof AuthedCatalogRoute
  '/categories': typeof AuthedCategoriesRoute
  '/charities': typeof AuthedCharitiesRoute
  '/claims': typeof AuthedClaimsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/diagnostics': typeof AuthedDiagnosticsRoute
  '/items': typeof AuthedItemsRoute
  '/launch-subscribers': typeof AuthedLaunchSubscribersRoute
  '/postal': typeof AuthedPostalRoute
  '/promo-codes': typeof AuthedPromoCodesRoute
  '/referrals': typeof AuthedReferralsRoute
  '/returns': typeof AuthedReturnsRoute
  '/schools': typeof AuthedSchoolsRoute
  '/tag-batches': typeof AuthedTagBatchesRoute
  '/tag-orders': typeof AuthedTagOrdersRoute
  '/tags': typeof AuthedTagsRoute
  '/users': typeof AuthedUsersRoute
  '/webhooks': typeof AuthedWebhooksRoute
  '/charities/$id': typeof AuthedCharitiesIdRoute
  '/promo-codes/$code': typeof AuthedPromoCodesCodeRoute
  '/schools/$id': typeof AuthedSchoolsIdRoute
  '/users/$uid': typeof AuthedUsersUidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/mfa-enroll': typeof MfaEnrollRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/_authed/api-keys': typeof AuthedApiKeysRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/catalog': typeof AuthedCatalogRoute
  '/_authed/categories': typeof AuthedCategoriesRoute
  '/_authed/charities': typeof AuthedCharitiesRoute
  '/_authed/claims': typeof AuthedClaimsRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/diagnostics': typeof AuthedDiagnosticsRoute
  '/_authed/items': typeof AuthedItemsRoute
  '/_authed/launch-subscribers': typeof AuthedLaunchSubscribersRoute
  '/_authed/postal': typeof AuthedPostalRoute
  '/_authed/promo-codes': typeof AuthedPromoCodesRoute
  '/_authed/referrals': typeof AuthedReferralsRoute
  '/_authed/returns': typeof AuthedReturnsRoute
  '/_authed/schools': typeof AuthedSchoolsRoute
  '/_authed/tag-batches': typeof AuthedTagBatchesRoute
  '/_authed/tag-orders': typeof AuthedTagOrdersRoute
  '/_authed/tags': typeof AuthedTagsRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_authed/webhooks': typeof AuthedWebhooksRoute
  '/_authed/charities_/$id': typeof AuthedCharitiesIdRoute
  '/_authed/promo-codes_/$code': typeof AuthedPromoCodesCodeRoute
  '/_authed/schools_/$id': typeof AuthedSchoolsIdRoute
  '/_authed/users_/$uid': typeof AuthedUsersUidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/login'
    | '/mfa-enroll'
    | '/mfa-verify'
    | '/api-keys'
    | '/audit'
    | '/catalog'
    | '/categories'
    | '/charities'
    | '/claims'
    | '/dashboard'
    | '/diagnostics'
    | '/items'
    | '/launch-subscribers'
    | '/postal'
    | '/promo-codes'
    | '/referrals'
    | '/returns'
    | '/schools'
    | '/tag-batches'
    | '/tag-orders'
    | '/tags'
    | '/users'
    | '/webhooks'
    | '/charities/$id'
    | '/promo-codes/$code'
    | '/schools/$id'
    | '/users/$uid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/login'
    | '/mfa-enroll'
    | '/mfa-verify'
    | '/api-keys'
    | '/audit'
    | '/catalog'
    | '/categories'
    | '/charities'
    | '/claims'
    | '/dashboard'
    | '/diagnostics'
    | '/items'
    | '/launch-subscribers'
    | '/postal'
    | '/promo-codes'
    | '/referrals'
    | '/returns'
    | '/schools'
    | '/tag-batches'
    | '/tag-orders'
    | '/tags'
    | '/users'
    | '/webhooks'
    | '/charities/$id'
    | '/promo-codes/$code'
    | '/schools/$id'
    | '/users/$uid'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/forbidden'
    | '/login'
    | '/mfa-enroll'
    | '/mfa-verify'
    | '/_authed/api-keys'
    | '/_authed/audit'
    | '/_authed/catalog'
    | '/_authed/categories'
    | '/_authed/charities'
    | '/_authed/claims'
    | '/_authed/dashboard'
    | '/_authed/diagnostics'
    | '/_authed/items'
    | '/_authed/launch-subscribers'
    | '/_authed/postal'
    | '/_authed/promo-codes'
    | '/_authed/referrals'
    | '/_authed/returns'
    | '/_authed/schools'
    | '/_authed/tag-batches'
    | '/_authed/tag-orders'
    | '/_authed/tags'
    | '/_authed/users'
    | '/_authed/webhooks'
    | '/_authed/charities_/$id'
    | '/_authed/promo-codes_/$code'
    | '/_authed/schools_/$id'
    | '/_authed/users_/$uid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  LoginRoute: typeof LoginRoute
  MfaEnrollRoute: typeof MfaEnrollRoute
  MfaVerifyRoute: typeof MfaVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/mfa-verify': {
      id: '/mfa-verify'
      path: '/mfa-verify'
      fullPath: '/mfa-verify'
      preLoaderRoute: typeof MfaVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-enroll': {
      id: '/mfa-enroll'
      path: '/mfa-enroll'
      fullPath: '/mfa-enroll'
      preLoaderRoute: typeof MfaEnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/webhooks': {
      id: '/_authed/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AuthedWebhooksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tags': {
      id: '/_authed/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof AuthedTagsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tag-orders': {
      id: '/_authed/tag-orders'
      path: '/tag-orders'
      fullPath: '/tag-orders'
      preLoaderRoute: typeof AuthedTagOrdersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tag-batches': {
      id: '/_authed/tag-batches'
      path: '/tag-batches'
      fullPath: '/tag-batches'
      preLoaderRoute: typeof AuthedTagBatchesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schools': {
      id: '/_authed/schools'
      path: '/schools'
      fullPath: '/schools'
      preLoaderRoute: typeof AuthedSchoolsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/returns': {
      id: '/_authed/returns'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof AuthedReturnsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/referrals': {
      id: '/_authed/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthedReferralsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/promo-codes': {
      id: '/_authed/promo-codes'
      path: '/promo-codes'
      fullPath: '/promo-codes'
      preLoaderRoute: typeof AuthedPromoCodesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/postal': {
      id: '/_authed/postal'
      path: '/postal'
      fullPath: '/postal'
      preLoaderRoute: typeof AuthedPostalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/launch-subscribers': {
      id: '/_authed/launch-subscribers'
      path: '/launch-subscribers'
      fullPath: '/launch-subscribers'
      preLoaderRoute: typeof AuthedLaunchSubscribersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/items': {
      id: '/_authed/items'
      path: '/items'
      fullPath: '/items'
      preLoaderRoute: typeof AuthedItemsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/diagnostics': {
      id: '/_authed/diagnostics'
      path: '/diagnostics'
      fullPath: '/diagnostics'
      preLoaderRoute: typeof AuthedDiagnosticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/claims': {
      id: '/_authed/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthedClaimsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/charities': {
      id: '/_authed/charities'
      path: '/charities'
      fullPath: '/charities'
      preLoaderRoute: typeof AuthedCharitiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/categories': {
      id: '/_authed/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AuthedCategoriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/catalog': {
      id: '/_authed/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AuthedCatalogRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/api-keys': {
      id: '/_authed/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof AuthedApiKeysRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users_/$uid': {
      id: '/_authed/users_/$uid'
      path: '/users/$uid'
      fullPath: '/users/$uid'
      preLoaderRoute: typeof AuthedUsersUidRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schools_/$id': {
      id: '/_authed/schools_/$id'
      path: '/schools/$id'
      fullPath: '/schools/$id'
      preLoaderRoute: typeof AuthedSchoolsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/promo-codes_/$code': {
      id: '/_authed/promo-codes_/$code'
      path: '/promo-codes/$code'
      fullPath: '/promo-codes/$code'
      preLoaderRoute: typeof AuthedPromoCodesCodeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/charities_/$id': {
      id: '/_authed/charities_/$id'
      path: '/charities/$id'
      fullPath: '/charities/$id'
      preLoaderRoute: typeof AuthedCharitiesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedApiKeysRoute: typeof AuthedApiKeysRoute
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedCatalogRoute: typeof AuthedCatalogRoute
  AuthedCategoriesRoute: typeof AuthedCategoriesRoute
  AuthedCharitiesRoute: typeof AuthedCharitiesRoute
  AuthedClaimsRoute: typeof AuthedClaimsRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDiagnosticsRoute: typeof AuthedDiagnosticsRoute
  AuthedItemsRoute: typeof AuthedItemsRoute
  AuthedLaunchSubscribersRoute: typeof AuthedLaunchSubscribersRoute
  AuthedPostalRoute: typeof AuthedPostalRoute
  AuthedPromoCodesRoute: typeof AuthedPromoCodesRoute
  AuthedReferralsRoute: typeof AuthedReferralsRoute
  AuthedReturnsRoute: typeof AuthedReturnsRoute
  AuthedSchoolsRoute: typeof AuthedSchoolsRoute
  AuthedTagBatchesRoute: typeof AuthedTagBatchesRoute
  AuthedTagOrdersRoute: typeof AuthedTagOrdersRoute
  AuthedTagsRoute: typeof AuthedTagsRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedWebhooksRoute: typeof AuthedWebhooksRoute
  AuthedCharitiesIdRoute: typeof AuthedCharitiesIdRoute
  AuthedPromoCodesCodeRoute: typeof AuthedPromoCodesCodeRoute
  AuthedSchoolsIdRoute: typeof AuthedSchoolsIdRoute
  AuthedUsersUidRoute: typeof AuthedUsersUidRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedApiKeysRoute: AuthedApiKeysRoute,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedCatalogRoute: AuthedCatalogRoute,
  AuthedCategoriesRoute: AuthedCategoriesRoute,
  AuthedCharitiesRoute: AuthedCharitiesRoute,
  AuthedClaimsRoute: AuthedClaimsRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDiagnosticsRoute: AuthedDiagnosticsRoute,
  AuthedItemsRoute: AuthedItemsRoute,
  AuthedLaunchSubscribersRoute: AuthedLaunchSubscribersRoute,
  AuthedPostalRoute: AuthedPostalRoute,
  AuthedPromoCodesRoute: AuthedPromoCodesRoute,
  AuthedReferralsRoute: AuthedReferralsRoute,
  AuthedReturnsRoute: AuthedReturnsRoute,
  AuthedSchoolsRoute: AuthedSchoolsRoute,
  AuthedTagBatchesRoute: AuthedTagBatchesRoute,
  AuthedTagOrdersRoute: AuthedTagOrdersRoute,
  AuthedTagsRoute: AuthedTagsRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedWebhooksRoute: AuthedWebhooksRoute,
  AuthedCharitiesIdRoute: AuthedCharitiesIdRoute,
  AuthedPromoCodesCodeRoute: AuthedPromoCodesCodeRoute,
  AuthedSchoolsIdRoute: AuthedSchoolsIdRoute,
  AuthedUsersUidRoute: AuthedUsersUidRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  LoginRoute: LoginRoute,
  MfaEnrollRoute: MfaEnrollRoute,
  MfaVerifyRoute: MfaVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
